import { create } from 'zustand'

const useNotificationStore = create((set) => ({
  permission: Notification.permission,
  requestPermission: async () => {
    try {
      const permission = await Notification.requestPermission()
      set({ permission })
      return permission
    } catch (error) {
      console.error('Error:', error)
      return 'denied'
    }
  },
  notify: (title, body) => {
    console.log('🔔 Notification triggered at:', new Date().toISOString(), 'Title:', title, 'Body:', body)
    if (Notification.permission !== 'granted') {
      console.warn('⚠️ Notification permission not granted:', Notification.permission)
      return false
    }
    console.log('✅ Creating browser notification')
    new Notification(title, { body })
    return true
  }
}))

export default useNotificationStore
